import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import RelatedContact from "./RelatedContact";
import {
  ContactContainerOuter,
  ContactContainerInfo,
  FormBody,
  OptionsWrapper,
  SectionContainer,
} from "./RelatedContacts.styled";

const RelatedContacts = (props) => {
  const { t, contactList, page } = props;

  return (
    <>
      <ContactContainerOuter>
        <ContactContainerInfo>
          <FormBody>
            <OptionsWrapper>
              <SectionContainer>
                {contactList.length > 0 &&
                  contactList.map((contactInfo, index) => {
                    if (page === "relatedContact")
                      contactInfo = contactInfo.contact;
                    return (
                      <RelatedContact
                        contactData={contactInfo}
                        key={
                          "kickoff_related_conatc_list" +
                          index +
                          contactInfo?.id +
                          Math.random()
                        }
                        type="list"
                      />
                    );
                  })}
              </SectionContainer>
            </OptionsWrapper>
          </FormBody>
        </ContactContainerInfo>
      </ContactContainerOuter>
    </>
  );
};

RelatedContacts.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};
RelatedContacts.defaultProps = {
  page: null,
};

export default withTranslation()(RelatedContacts);
